// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2c_Lh","title":"Info_title__3s-kX","selects":"Info_selects__2FZek","requiredAsterisk":"Info_requiredAsterisk__los_k"};